module.exports = __webpack_public_path__ + "static/media/SplashImage.45b440e9.png";